import logger from "@next/core-logger"
import {IncomingHttpHeaders} from "http"
import {createAxiosInstance} from "@next/axios"
import CountriesApiConfig from "../../config/api/countries"
import {Country as CountryType} from "../../models/countryselector"
import env from "../../config/env"

export const getCountriesList = async (
    baseUrl: string,
    _headers: IncomingHttpHeaders,
    countrySelectorEndpoint: string,
): Promise<CountryType[]> => {
    try {
        const {PORT, DEV_URL_OVERRIDE} = env
        const axios = createAxiosInstance({
            PORT,
            REACT_APP_APP_URL: DEV_URL_OVERRIDE,
        })

        const getCountriesListDataApi = CountriesApiConfig("getCountriesListData")
        const response = await axios({
            method: getCountriesListDataApi.method,
            url: `${baseUrl}${countrySelectorEndpoint}`,
        })
        return response.data
    } catch (error) {
        const ex = error as Error
        logger.error(ex)
        throw ex
    }
}

export default getCountriesList
